'use strict'

const actions = {
  showSnackbar ({ commit }, data) {
    commit('SHOW_SNACKBAR', data)
  },
  closeSnackbar ({ commit }) {
    commit('CLOSE_SNACKBAR')
  },
  setSelectedShipment ({ commit }, index) {
    commit('SET_SELECTED_SHIPMENT', index)
  },
  startOrdersAction ({ commit }) {
    commit('START_ORDERS_ACTION')
  },
  endOrdersAction ({ commit }) {
    commit('END_ORDERS_ACTION')
  },
  selectPackage ({ commit }, pckg) {
    commit('SELECT_PACKAGE', pckg)
  },
  unselectPackage ({ commit }, pckg) {
    commit('UNSELECT_PACKAGE', pckg)
  },
  unselectOrder ({ commit }, order) {
    commit('UNSELECT_ORDER', order)
  },
  startLoading ({ commit }) {
    commit('SET_LOADING', true)
  },
  stopLoading ({ commit }) {
    commit('SET_LOADING', false)
  },
  async setLoadingTime ({ commit }, miliseconds) {
    commit('SET_LOADING', true)
    await new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('SET_LOADING', false)
        resolve()
      }, miliseconds)
    })
  },
  setDateFilter ({ commit }, data) {
    commit('SET_DATE_FILTER', data)
  },
  setAllSelectedFilters ({ commit }, data) {
    commit('SET_ALL_SELECTED_FILTERS', data)
  },
  clearDateFilter ({ commit }) {
    commit('CLEAR_DATE_FILTER')
  },
  setDrawerMenu ({ commit }, value) { // TODO: Probably just temporal thing
    commit('SET_DRAWER_MENU', value)
  },
  selectCustomFilter ({ commit }, data) {
    commit('SELECT_CUSTOM_FILTERS', data)
  },
  clearSelectedCustomFilters ({ commit }) {
    commit('CLEAR_SELECTED_CUSTOM_FILTERS')
  }
}

export default actions
